'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import UIFlex from 'UIComponents/layout/UIFlex';
import H2 from 'UIComponents/elements/headings/H2';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UILink from 'UIComponents/link/UILink';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import ReviewStats from 'marketplace-ui-reviews/records/ReviewStats';
import OverallDistribution from './OverallDistribution';
import QualityDistribution from './QualityDistribution';
import { RatingAxes } from '../../constants/reviews/RatingAxes';
import LegacyReviewStats from '../../records/ReviewStats';
import Rating from './Rating';
const RatingNumberDisplay = styled(H2).withConfig({
  displayName: "ReviewsListStats__RatingNumberDisplay",
  componentId: "sc-9e1dnm-0"
})(["font-weight:700;font-size:56px;line-height:56px;margin-bottom:4px;"]);
const ColumnBlock = styled.div.withConfig({
  displayName: "ReviewsListStats__ColumnBlock",
  componentId: "sc-9e1dnm-1"
})(["width:100%;padding-top:20px;padding-bottom:20px;border-bottom:1px solid ", ";"], GREAT_WHITE);
const RowBlock = styled.div.withConfig({
  displayName: "ReviewsListStats__RowBlock",
  componentId: "sc-9e1dnm-2"
})(["width:auto;"]);
const textPath = 'ecosystemMarketplaceCore.reviews.stats';

const ReviewsListStats = (_ref) => {
  let {
    allReviewsHref,
    className,
    inline,
    onUpdateFilters,
    reviewStats,
    reviewType
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["allReviewsHref", "className", "inline", "onUpdateFilters", "reviewStats", "reviewType"]);

  const overallRatingAvg = reviewStats.getAxisAverage(RatingAxes.OVERALL);
  const hasQualityRatings = reviewStats.hasQualityRatings();
  const flexDirection = inline ? 'row' : 'column';
  const flexWidth = inline ? '100%' : 'auto';
  const flexJustify = hasQualityRatings ? 'between' : 'start';
  const Block = inline ? RowBlock : ColumnBlock;
  return /*#__PURE__*/_jsxs(UIFlex, Object.assign({
    direction: flexDirection,
    justify: flexJustify,
    style: {
      width: flexWidth
    },
    className: className
  }, rest, {
    children: [/*#__PURE__*/_jsxs(Block, {
      style: {
        paddingTop: '0',
        paddingRight: hasQualityRatings ? '16px' : '40px'
      },
      children: [/*#__PURE__*/_jsx(RatingNumberDisplay, {
        children: /*#__PURE__*/_jsx(FormattedNumber, {
          value: overallRatingAvg,
          precision: 1
        })
      }), /*#__PURE__*/_jsx(Rating, {
        rating: overallRatingAvg,
        direction: "column",
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${textPath}.reviewCount`,
          options: {
            count: reviewStats.get('count')
          }
        }),
        labelSize: "medium"
      }), allReviewsHref && /*#__PURE__*/_jsx("div", {
        className: "m-top-2",
        children: /*#__PURE__*/_jsx(UILink, {
          href: allReviewsHref,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${textPath}.seeAllReviews`
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Block, {
      children: /*#__PURE__*/_jsx(OverallDistribution, {
        className: inline ? 'm-all-auto' : "",
        onUpdateFilters: onUpdateFilters,
        reviewStats: reviewStats
      })
    }), hasQualityRatings && /*#__PURE__*/_jsx(Block, {
      children: /*#__PURE__*/_jsx(QualityDistribution, {
        heading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystemMarketplaceCore.reviews.qualityDistribution.heading"
        }),
        labelSize: "md",
        qualityRatings: reviewStats.getQualityRatings(),
        reviewType: reviewType,
        showLabelTooltips: true
      })
    })]
  }));
};

ReviewsListStats.propTypes = {
  allReviewsHref: PropTypes.string,
  className: PropTypes.string,
  inline: PropTypes.bool.isRequired,
  onUpdateFilters: PropTypes.func.isRequired,
  reviewStats: PropTypes.oneOfType([PropTypes.instanceOf(LegacyReviewStats), PropTypes.instanceOf(ReviewStats)]).isRequired,
  reviewType: PropTypes.oneOf(Object.values(ReviewTypes)).isRequired
};
ReviewsListStats.defaultProps = {
  inline: false
};
export default ReviewsListStats;